const merchantAuth = {
    path: 'merchantAuth',
    component: resolve => require(['@/pages/admin/aftersales/merchantAuth/index.vue'], resolve),
    meta: {
        requireAuth: true
    },
    children: [

    ]
}

export default merchantAuth